<template>
    <div id="agaccount" class='gcardfr' v-loading='loading'>

        <el-row :gutter="20" class=''>
            <el-col :span='8'>
                <div class="glineflex">
                    <label class="glinelb">商户ID：</label>
                    <el-input size='small' v-model='merchantId' @keyup.enter.native="indexget"></el-input>
                </div>
            </el-col>
            <el-col :span='8'>
                <div class="glineflex">
                    <label class="glinelb">设备ID：</label>
                    <el-input size='small' v-model='deviceId' @keyup.enter.native="indexget"></el-input>
                </div>
            </el-col>

        </el-row>
        <el-table class='gtbtop' tooltip-effect="dark" :data="tableData" style="width: 100%">
            <el-table-column prop="devicename" label="设备名称">
            </el-table-column>
            <el-table-column prop="deviceid" label="设备ID">
            </el-table-column>
            <el-table-column prop="merchantName" label="商户名称">
            </el-table-column>
            <el-table-column prop="merchantId" label="商户ID" width="200">
            </el-table-column>
            <el-table-column label="状态" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == '0'">未初始化</span>
                    <span v-if="scope.row.status == '1'">语料下发中</span>
                    <span v-if="scope.row.status == '2'">语料下发完成</span>
                    <span v-if="scope.row.status == '3'">语料下发失败</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200">
            </el-table-column>
        </el-table>

        <Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>
    </div>
</template>

<style>
.edttcolor {
    margin-top: 20px;
}

.eqbs-ball-green {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(82, 196, 26, 1);
}

.eqbs-ball-gray {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(191, 191, 191, 1);
}
</style>

<script>
import Pages from '@/components/Pages.vue'
export default {
    data() {
        return {
            deviceId: '',
            merchantId: '',
            forms: {},
            isEdit: false,
            srcKey: '',
            pconfig: '',
            tableData: [],
            showDia: false,
            uform: {
                strategyData: {}
            },
            page: 1,
            total: 0,
            loading: false,
            sRows: [],
            innerVisible: false,
            beginTime: '',
            endTime: '',
        }
    },
    components: {
        Pages,
    },
    methods: {
        indexget() {
            this.page = 1
            this.getList()
        },
        getList() {
            this.loading = true
            this.$marketDevice(this.page, this.$gRow, this.deviceId, this.merchantId, res => {
                this.loading = false
                if (res.status == 200) {
                    this.total = res.total
                    this.tableData = res.data
                } else {
                    this.$message.error(res.message)
                }
            }, '')
        },
        batchSelected(val) {
            this.sRows = val
        },
        closeDia() {
            this.showDia = false
            this.uform = { strategyData: {} }
        },
    },
    mounted() {
        var _this = this
        this.pconfig = {
            callback: page => {
                ///
                _this.page = page
                _this.getList()
            }
        }

        // this.setMc('')

        this.getList()
    }
}
</script>
